import { LayoutGroup } from "framer-motion";

import CertificationCatalogueItem from "./CertificationCatalogueItem";
import CertificationSpecialCreditsModal from "./CertificationSpecialCreditsModal";
import { useCertification } from "~/hooks";

const CertificationCatalogue = () => {
	const {
		certification: { modules, specialCredits, specialCreditsNote },
	} = useCertification();

	return (
		<div className="flex flex-col gap-1" id="certification-catalogue">
			<LayoutGroup>
				{modules.map((module, i) => (
					<CertificationCatalogueItem module={module} key={i} />
				))}

				{!!specialCredits && (
					<CertificationSpecialCreditsModal
						note={specialCreditsNote!}
						specialCredits={specialCredits}
					/>
				)}
			</LayoutGroup>
		</div>
	);
};

export default CertificationCatalogue;
